export const api_logout = () => {
  return useHttp("/auth/logout");
};
export const api_loginWithGoogle = (
  credential: string,
  showLoading: boolean = true
) => {
  console.log("api_loginWithGoogle");
  return useHttp("/auth/google/login", {
    method: "POST",
    body: {
      idToken: credential,
    },
  });
};

export const api_loginWithApple = (
  idToken: string,
  showLoading: boolean = true
) => {
  return useHttp("/auth/apple/login", {
    method: "POST",
    body: {
      idToken,
    },
  });
};

export const api_loginWithFacebook = (idToken: string) => {
  return useHttp("/auth/facebook/login", {
    method: "POST",
    body: {
      idToken,
    },
  });
};
export const api_loginByCodeFacebook = (code: string) => {
  return useHttp("/auth/facebook/login_by_code", {
    method: "GET",
    params: {
      code,
      redirect_url: import.meta.env.VITE_FACEBOOK_CALLBACK_URL,
    },
  });
};

export const api_getTgStartId = () => {
  return useFetch(`${useRuntimeConfig().public.apiBase}/auth/telegram/start`);
  // return useHttp("/auth/telegram/start");
};

export const api_loginWithTelegram = (
  idToken: string = "",
  login_source: string = ""
) => {
  let params = login_source ? { login_source } : {};
  return useHttp("/auth/telegram/login", {
    params,
    method: "POST",
    body: {
      idToken,
    },
  });
};

export const api_loginWithTwitter = (
  {
    oauthToken,
    oauthVerifier,
    callback,
  }: {
    oauthToken: string;
    oauthVerifier: string;
    callback?: string;
  },
  showLoading: boolean = true
) => {
  return useHttp("/auth/twitter/v2/login", {
    method: "POST",
    body: {
      code: oauthToken,
      code_verifier: oauthVerifier,
      callback: callback ? callback : location?.origin,
    },
  });
};
